var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.24 45.542 36.914 33.165c3.17-3.637 4.906-8.213 4.906-12.978C41.82 9.057 32.44 0 20.91 0S0 9.056 0 20.187C0 31.32 9.38 40.375 20.91 40.375c4.328 0 8.453-1.26 11.98-3.653l12.419 12.47c.519.521 1.217.808 1.965.808.708 0 1.38-.26 1.89-.735a2.572 2.572 0 0 0 .076-3.723ZM20.91 5.266c8.522 0 15.455 6.694 15.455 14.921 0 8.228-6.933 14.922-15.455 14.922S5.455 28.415 5.455 20.187c0-8.227 6.933-14.92 15.455-14.92Z"
  })));
};

export default SvgSearch;